import Select from './Select';

export type { SelectProps } from './Select';

export default Select;
